import React, { useState } from 'react';
import '../styles/Page.css';

function Page() {
    return (
        <div className='page'>
            <div>
                <img src="img/SpaceOut1.jpg" />
                <img src="img/SpaceOut4.png" />
                <img src="img/SpaceOut5.png" />
                <img src="img/SpaceOut3.png" />

                <p style={{ textAlign: 'right' }}><i>Space Out</i>, 2021. Multimedia, Art Center Nabi, Seoul.</p>
                <p><i>Space Out</i> is a virtual space that encourages you to discover stories overseen by the hero’s journey motif that constitutes many existing games. Starting at the ending credit after defeating the final boss, you will be walking through a field with no enemy or puzzle towards the point where the game had begun and a new one will begin – it is a contemplative process of apprehending things that had been lost.</p>
                <p style={{ fontSize: '18px' }}>Text & Photographs are provided by Art Center Nabi</p>

                <p><i>Credits</i></p>
                <p style={{ fontSize: '18px' }}>Lead Producer: Sima Kim
                    <br />Script: Easel
                    <br />Programming: Sima Kim
                    <br />2D Artist: Yoyojin
                    <br />3D Artist: Beuroock
                    <br />3D Support Artist: Sima Kim
                    <br />Technical Artist: Sima Kim
                    <br />Graphic & UX Design: Sima Kim
                    <br />Music: Kenji Komine(LSTNGT)
                    <br />Consulting & QA: isvn, Supersaladstuff, Alter Kim
                    <br /><br />
                    Directed by Sima Kim<br />
                    Supported by Art Center Nabi</p>
                <br />

            </div>
        </div>

    )
}

export default Page;